import React, { useCallback } from 'react'
import styled from 'styled-components'
import { login } from '../../../utils/login'
import { getLinkTarget } from '../../utils/getLinkTarget'
import {
  MORE_INFO_ECO_ID_URL
} from '../Header/HeaderLogin/LoginModal/LoginModal'
import { EmailConsumer } from '../../../context/Email'
import { isResponseFull } from '../Email/EmailUtils'
import Loader from '../../utils/Loader'

export const EcoIdLoginPromo = ({
  ecoIdentity: {
    clientId,
    login: {
      location: loginLocation
    }
  },
  activeDynamicLayout
}) => {
  const handleLogin = useCallback(() => {
    login({ loginLocation, clientId })
  }, [loginLocation, clientId])

  return (
    <EmailConsumer>
      {({ inbox, isLoading }) => {
        const isLoggedIn = isResponseFull(inbox)

        if (isLoggedIn) {
          return null
        }

        return (
          <StyledContainer>
            {isLoading && <Loader/>}
            <StyledContainer2>
              <StyledText>Přihlášení do e-mailu (z)mění svou podobu</StyledText>
              <StyledButton onClick={handleLogin}>Nové přihlášení</StyledButton>
            </StyledContainer2>
            <StyledLineBreak />
            <StyledMoreInformation
              href={MORE_INFO_ECO_ID_URL}
              target={getLinkTarget(activeDynamicLayout)}
            >
              Více informací
            </StyledMoreInformation>
          </StyledContainer>
        )
      }}
    </EmailConsumer>
  )
}

const StyledContainer2 = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const StyledContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.ecoIdLoginPromo.container.backgroundColor};
  padding: 20px 12px 12px;
  gap: 8px;
  margin-bottom: 12px;
`

const StyledText = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: ${({ theme }) => theme.ecoIdLoginPromo.text.color};
`

const StyledButton = styled.button`
  min-height: 40px;
  height: 100%;
  min-width: 88px;
  background-color: ${({ theme }) => theme.ecoIdLoginPromo.button.backgroundColor};
  border: none;
  color: ${({ theme }) => theme.ecoIdLoginPromo.button.color};
  text-transform: uppercase;
  font-size: 12px;
  font-weight: bold;
  line-height: 16px;

  :hover {
    background-color: ${({ theme }) => theme.ecoIdLoginPromo.button.backgroundHoverColor};
  }
`

const StyledMoreInformation = styled.a`
  color: ${({ theme }) => theme.ecoIdLoginPromo.moreInfo.color};
  text-decoration: underline;
  font-size: 14px;

  :hover {
    color: ${({ theme }) => theme.ecoIdLoginPromo.moreInfo.hoverColor};
  }
`

const StyledLineBreak = styled.div`
  width: 100%;
`
